module.exports = __webpack_public_path__ + "static/media/quote.6f326127.svg";